import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChatOpenService {
  private _open$ = new Subject<void>();
  readonly open$ = this._open$.asObservable();

  requestOpen() { this._open$.next(); }
}
